












import {Vue, Component} from 'vue-property-decorator';
import Logo from '@/components/common/Logo.vue';
@Component({
  components: { Logo },
})
export default class ServiceRegisterHeader extends Vue {
}
